import {
    Button,
    Dialog,
    Tab,
    Tabs,
    PullRefresh,
    RadioGroup,
    Radio,
    CountDown,
    Sticky,
    Cell,
    Checkbox,
    Image,
    Toast,
} from 'vant'

export default {
    install: function (app: any): void {
        app.use(Dialog)
            .use(Button)
            .use(Tab)
            .use(Tabs)
            .use(PullRefresh)
            .use(RadioGroup)
            .use(Radio)
            .use(CountDown)
            .use(Sticky)
            .use(Cell)
            .use(Checkbox)
            .use(Image)
            .use(Toast)
    },
}
